import type { DefaultError, Query, QueryKey } from "@tanstack/vue-query";

export const emptyGuid = "00000000-0000-0000-0000-000000000000";
export const notFoundRouteName = "NotFound";
export const getIsUserRegisteredForGiveawayCookieKey = (giveawaySlug: string) =>
  `isUserRegisteredForGiveaway_${giveawaySlug}`;

export const SEARCH_INPUT_ID = "global-search-input";
export const SEARCH_MODAL_CONTENT_ID = "search-modal-content";
export const EXCLUDED_COUNTRY_CODES = ["PS"];
export const DEFAULT_STALE_TIME_MS = 15 * 1000; // 15 seconds

/**
 * Stale time for queries when running on the server.
 *
 * This ensures that data fetched during server-side rendering is always considered stale,
 * prompting a refetch on the client side to get the most up-to-date information.
 */
export const getStaleOnServer = <
  TQueryFnData = unknown,
  TError = DefaultError,
  TData = TQueryFnData,
  TQueryKey extends QueryKey = QueryKey,
>(
  queryData: Query<TQueryFnData, TError, TData, TQueryKey>,
  clientStaleTime: number = DEFAULT_STALE_TIME_MS,
) => {
  // we don't concern about staleness on the server as it runs only once
  if (import.meta.server) return Infinity;

  // always stale on first client render
  if (queryData.state.dataUpdateCount === 1) return 0;

  return clientStaleTime;
};
